// imports
import * as THREE from "three"

// classes
import Time from "./Utilis/Time"
import Sizes from "./Utilis/Sizes"
import Sources from "./Source";
import Shaders from "./Shaders/Shaders";
import Overlay from "./Overlay";
import Debug from "./Utilis/Debug";
import Camera from "./Camera"
import Controls from "./Controls";
import Renderer from "./Utilis/Renderer"
import ResourceLoader from "./Utilis/ResourceLoader"
import World from "./World/World";
import CharacterControls from "./Utilis/CharacterControls";
import AnimationController from "./Utilis/AnimationController";

let instance;
export default class Experience
{
    constructor( _options )
    {
        if ( instance )
            return instance
        instance = this


        // setup
        this.app = _options.app
        this.canvas = _options.canvas
        this.scene = new THREE.Scene()

        // options
        this.time = new Time()
        this.sizes = new Sizes()
        this.sources = new Sources()
        this.shaders = new Shaders()
        this.animationController = new AnimationController()
        this.debug = new Debug()
        
        this.camera = new Camera()
        this.controls = new Controls()
        this.renderer = new Renderer()
        
        this.overlay = new Overlay()
        this.resourceLoader = new ResourceLoader()
        
        this.world = new World()
        
        this.sizes.on( "resize", () => this.resize() )
        this.time.on( "tick", () => this.update() )
        this.resourceLoader.on( "itemsLoaded", () =>
        {
            this.characterControls = new CharacterControls()

            if ( this.debug.active )
                this.debug.setHelpers()
                this.setDebug()
        } )
    }

    resize()
    {
        this.camera.resize()
        this.renderer.resize()
    }

    update()
    {
        if ( this.debug.stats )
            this.debug.stats.begin()

        this.controls.update()
        if ( this.animationController.updateAnimation )
            this.animationController.update()

        this.world.update()
        this.renderer.update()
        
        if ( this.debug.stats )
            this.debug.stats.end()
    }

    setDebug()
    {
        this.camera.setDebug()
        this.controls.setDebug()
        this.characterControls.setDebug()
        this.renderer.setDebug()
        this.world.setDebug()
    }
}